import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { Column } from '@app/modules/table/classes/column.class';

export class HiredAtColumn extends Column {
    title = 'table.employeesDirectory.hireDate';
    property = 'hiredAt';
    sortable = true;
    type: CellDisplay = CellDisplay.date;
}
